import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es material digital?',
    a: 'Sí, acceso y descarga inmediata.'
  }, {
    q: '¿Es solo para madres?',
    a: 'No. También sirve para mujeres que viven solas, parejas, estudiantes y familias.'
  }, {
    q: '¿Incluye ideas para viandas?',
    a: 'Sí, incluye ideas para viandas laborales, escolares y semanales.'
  }, {
    q: '¿Incluye opciones sin TACC?',
    a: 'Sí, y además podés sumar el upsell específico Sin TACC.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-sage py-16 px-4 flex flex-col items-center" data-id="element-34">
      <div className="max-w-3xl w-full" data-id="element-35">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-10 text-center" data-id="element-36">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-green-100 overflow-hidden" data-id="element-38">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-39">
                <span className="font-bold text-brown-800 text-lg pr-4" data-id="element-40">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="text-gold-500 shrink-0" data-id="element-41" /> : <ChevronDown className="text-brown-400 shrink-0" data-id="element-42" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-43">
                <p className="text-brown-600 text-lg" data-id="element-44">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}